export function StatusBadge({ status }) {
  const published = status === "published";
  return (
    <span
      data-testid={`status-badge-${status}`}
      className={`inline-flex items-center gap-1.5 rounded-full px-2.5 py-0.5 text-xs font-semibold ${
        published ? "bg-[#ECFDF5] text-[#047857]" : "bg-[#FFFBEB] text-[#B45309]"
      }`}
    >
      <span className={`h-1.5 w-1.5 rounded-full ${published ? "bg-[#10B981]" : "bg-[#F59E0B]"}`} />
      {published ? "Published" : "In Progress"}
    </span>
  );
}

export function ProgressBar({ value }) {
  return (
    <div className="h-1.5 w-full rounded-full bg-slate-100" data-testid="progress-bar">
      <div
        className="h-1.5 rounded-full bg-[#EA580C] transition-[width] duration-300"
        style={{ width: `${value}%` }}
      />
    </div>
  );
}
